import React, { useEffect } from 'react';
import { CContainer, CButton } from '@coreui/react';
import { cilPlus } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { useNavigate } from 'react-router-dom';
import CompositionTable from '../../components/CompositionTable/CompositionTable';
import { getCompositionRequestAction } from '../../store/composition/compositionActions';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';

const Composition = ({ compositionList, compositionData, getCompositionRequest }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    getCompositionRequest({});
  }, [getCompositionRequest]);

  const handleCreate = () => {
    navigate('/composition/create');
  };

  return (
    <div className="composition-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('compositions')}</div>
        <CompositionTable compositionList={compositionList} compositionData={compositionData} />
      </CContainer>

      <CButton 
        color="primary" 
        className="create-order-fab" 
        onClick={handleCreate}
        title={t('createComposition')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

const mapStateToProps = (state) => ({
  compositionData: state.compositionReducer.compositionData,
  compositionList: state.compositionReducer.compositionList,
});

const mapDispatchToProps = (dispatch) => ({
  getCompositionRequest: (payload) => dispatch(getCompositionRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Composition);
